export enum SettingsPurchasePriceError {
  None = 0,
  Calculation = 1,
  SeatSize = 2
}
